import { WeModApiClient } from './api-client';

const apiClient = new WeModApiClient(process.env.NEXT_PUBLIC_WEMOD_API_URL ?? '');

interface AuthJwtResponse {
    token: string;
}

export async function getAuthJwt(service: string): Promise<string> {
    const response = await apiClient.post<AuthJwtResponse>('/v3/auth/jwt', { service });

    return response.token;
}
